<!--note: table: 0 la trong, 1 la dang cho len mon, 2 la da len mon-->
<!--note: order: 0 la chua thanh toan, 1 la da thanh toan -->
<!--van de: order da thanh toan se gan lien voi ban, nghia la ban chuyen ve 0 thi order day dc coi la chua len mon-->
<!--tim table theo id -->
<template>
  <div class="app">
    <!-- LEFT -->
    <div class="left">
      <!-- Tables -->
      <div class="card">
        <div style="display:flex;justify-content:space-between;align-items:center">
          <strong>Bàn / Khu vực</strong>
          <button class="btn ghost" @click="createNewTable">Tạo bàn</button>
        </div>
        <div style="margin-top:8px">
          <input v-model="searchTable" placeholder="Tìm bàn..."
                 style="width:100%;padding:8px;border-radius:8px;border:1px solid #eee"/>
        </div>
        <div class="tables">
          <div v-for="t in filteredTables" :key="t.id"
               class="table"
               :class="[{ active: selectedTableID === t.id }, 'status-' + (t.status || 0)]"
               @click="selectTable(t)">
            {{ t.name }}
          </div>
        </div>
      </div>

      <!-- Categories -->
      <div class="card" style="flex:1">
        <div style="display:flex;justify-content:space-between;align-items:center">
          <strong>Danh mục</strong>
          <div style="color:var(--muted)">{{ categories.length }} loại</div>
        </div>

        <div class="categories">
          <div v-for="cat in categories" :key="cat"
               class="cat"
               :class="{ active: selectedCategory === cat }"
               @click="selectedCategory = cat">
            {{ cat.name }}
          </div>
          <button class="btn ghost" style="margin-left:auto" @click="showAddFood = true">➕ Thêm món</button>
          <button class="btn ghost" style="margin-left:8px" @click="showAddCategory = true">➕ Thêm danh mục</button>
        </div>
      </div>
    </div>

    <!-- CENTER -->
    <div class="center">
      <div class="card center-header">
        <div>
          <h3>Menu gọi món</h3>
          <div style="color:var(--muted);font-size:13px">
            {{ selectedTable.name || 'Chưa chọn bàn' }}
          </div>

          <div class="search" style="margin-top:8px">
            <input v-model="search" placeholder="Tìm món, mã, mô tả..."/>
            <button class="btn ghost" @click="search = ''">X</button>
          </div>
        </div>
      </div>

      <div class="card" style="flex:1;overflow:auto;padding:12px">
        <div class="foods">
          <div v-for="food in filteredFoods" :key="food.id" class="food" @click="add(food)">
            <div class="name">{{ food.name }}</div>
            <div class="meta">Mã: {{ food.id }}</div>
            <div class="price">{{ formatMoney(food.price) }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT -->
    <div class="right">
      <div class="card">
        <div class="cart-header">
          <strong>Hóa đơn</strong>
          <div style="color:var(--muted);font-size:13px">
            Trạng thái: <span>Mới</span>
          </div>
        </div>
        <div style="margin-top:8px;color:var(--muted);font-size:13px">
          <span>{{ selectedTable.name || '-' }}</span>
        </div>
      </div>

      <div class="card cart-list">
        <div v-if="cart.length === 0" style="padding:12px;color:var(--muted)">Chưa có món nào</div>
        <div v-else v-for="(ci,i) in cart" :key="i" class="cart-item">
          <div style="flex:1">
            <div style="font-weight:600">{{ ci.name }}</div>

            <!-- Hiển thị ghi chú -->
            <div v-if="ci.note" style="font-size:12px;color:var(--muted);margin-top:2px">
              📝 {{ ci.note }}
            </div>

            <!-- Ô nhập ghi chú riêng cho món -->
            <input v-model="ci.note"
                   placeholder="Ghi chú món này (vd: ít đá, không cay)"
                   style="width:100%;margin-top:6px;padding:6px;border-radius:6px;border:1px solid #eee;font-size:13px"/>
          </div>

          <div style="text-align:right">
            <div style="font-weight:700">{{ formatMoney(ci.price * ci.qty) }}</div>
            <div class="qty" style="margin-top:6px">
              <button @click="changeQty(ci.id,-1)">-</button>
              <span>{{ ci.qty }}</span>
              <button @click="changeQty(ci.id,1)">+</button>
            </div>
          </div>
        </div>


      </div>

      <div class="card cart-bottom">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">
          <div>
            <div style="color:var(--muted);font-size:13px">Tổng tiền</div>
            <div style="font-size:18px;font-weight:700">{{ formatMoney(total) }}</div>
          </div>
          <div style="display:flex;flex-direction:column;gap:8px">
            <button v-if="!currentOrder" class="btn" @click="checkout" style="background-color: #111111">Gọi món
            </button>
            <button v-else-if="selectedTable.status == 2" class="btn" @click="payOrder"
                    style="background-color: #111111">Thanh toán
            </button>

          </div>
        </div>
        <div style="display:flex;gap:8px;align-items:center">
          <input v-model="note" placeholder="Ghi chú (vd: ít ngọt)"
                 style="flex:1;padding:8px;border-radius:8px;border:1px solid #eee"/>
          <button class="btn ghost" @click="clearCart">Xóa</button>
        </div>
      </div>
    </div>

    <!-- AddFood Popup -->
    <div v-if="showAddFood" class="modal-overlay" @click.self="showAddFood = false">
      <div class="modal-content">
        <AddFood @food-added="onFoodAdded" @close="showAddFood = false"/>
      </div>
    </div>

    <!-- AddCategory Popup -->
    <div v-if="showAddCategory" class="modal-overlay" @click.self="showAddCategory = false">
      <div class="modal-content">
        <h4>➕ Thêm danh mục mới</h4>
        <input v-model="newCategory" placeholder="Tên danh mục"
               style="margin-bottom:12px;width:100%;padding:8px;border-radius:8px;border:1px solid #eee"/>
        <div style="display:flex;gap:8px">
          <button class="btn" style="background-color: #00cec9; color: white" @click="addCategory">Thêm</button>
          <button class="btn ghost" @click="showAddCategory = false">Huỷ</button>
        </div>
      </div>
    </div>

    <!-- AddTable Popup -->
    <div v-if="showAddTable" class="modal-overlay" @click.self="showAddTable = false">
      <div class="modal-content">
        <h4>➕ Tạo bàn mới</h4>
        <input v-model="newTableName" placeholder="Tên bàn (vd: Bàn 1)"
               style="margin-bottom:12px;width:100%;padding:8px;border-radius:8px;border:1px solid #eee"/>
        <div style="display:flex;gap:8px">
          <button class="btn" style="background-color: #00cec9; color: white" @click="addTable">Tạo</button>
          <button class="btn ghost" @click="showAddTable = false">Huỷ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue'
import {createCat, getCategory, getFoods, getTable, createTable} from '../services/foods.js'
import {createOrder, getOrdersByTable, paymentOrder} from '../services/orders.js'
import AddFood from './AddFood.vue'

const foods = ref([])
const tables = ref([])
const cart = ref([])
const search = ref('')
const note = ref('')
const viewMode = ref('all')
const selectedCategory = ref('Tất cả')
const categories = ref([])
console.log(categories)
const selectedTable = ref([])
const selectedTableID = ref(null)
const searchTable = ref('')
const showAddFood = ref(false)
const showAddCategory = ref(false)
const newCategory = ref('')
const showAddTable = ref(false)
const newTableName = ref('')

onMounted(async () => {
  foods.value = await getFoods()
  categories.value = await getCategory()
  tables.value = await getTable()
})

const filteredTables = computed(() =>
    tables.value.filter(t => t.name.toLowerCase().includes(searchTable.value.toLowerCase()))
)

const filteredFoods = computed(() => {
  return foods.value.filter(f => {
    const matchSearch = f.name.toLowerCase().includes(search.value.toLowerCase())
    const matchCat = selectedCategory.value === 'Tất cả' || f.category?.name === selectedCategory.value
    const matchView = viewMode.value === 'all' || (viewMode.value === 'popular' && f.popular)
    return matchSearch && matchCat && matchView
  })
})

function mapOrderItemsToCartItems(order) {
  // Chuyển đổi order.items sang dạng cart
  return order.items.map(item => ({
    id: item.food.id,
    name: item.food.name,
    price: item.price,
    qty: item.qty,
    note: item.note
  }));
}

const currentOrder = ref(null) // order đang pending của bàn

async function selectTable(t) {
  selectedTable.value = t
  selectedTableID.value = t.id
  console.log(t.id)
  try {
    const orders = await getOrdersByTable(t.id)
    const pendingOrder = orders.find(o => o.status === '0')
    if (pendingOrder) {
      currentOrder.value = pendingOrder
      cart.value = mapOrderItemsToCartItems(pendingOrder)
      note.value = pendingOrder.note || ''
    } else {
      currentOrder.value = null
      cart.value = []
      note.value = ''
    }
  } catch (e) {
    currentOrder.value = null
    cart.value = []
    note.value = ''
    console.error('Lỗi lấy order của bàn:', e)
  }
}

async function payOrder() {
  if (!currentOrder.value) return alert('Không có đơn để thanh toán.')
  try {
    // ví dụ bạn có API updateOrderStatus
    await paymentOrder(currentOrder.value.id, 1) // 1 = đã thanh toán
    alert('Thanh toán thành công!')
    cart.value = []
    note.value = ''
    currentOrder.value = null
    window.location.reload()
  } catch (e) {
    console.error(e)
    alert('Có lỗi khi thanh toán.')
  }
}

function add(food, note) {
  if (!selectedTableID.value) return alert('Vui lòng chọn bàn trước khi gọi món.')
  const item = cart.value.find(i => i.id === food.id)
  if (item) item.qty++
  else cart.value.push({...food, qty: 1, note: note})
}

function changeQty(id, delta) {
  const it = cart.value.find(c => c.id === id)
  if (!it) return
  it.qty += delta
  if (it.qty <= 0) cart.value = cart.value.filter(c => c.id !== id)
}

function clearCart() {
  if (confirm('Xóa toàn bộ món?')) cart.value = []
}

async function checkout() {
  if (cart.value.length === 0) return alert('Chưa có món để thanh toán.')
  const orderData = {
    tableId: selectedTableID.value,
    items: cart.value.map(item => ({
          foodId: item.id,
          qty: item.qty,
          price: item.price,
          note: item.note
        }
    )),
    note: note.value
  }
  console.log(orderData)
  try {
    await createOrder(orderData)
    alert('Gọi món thành công!')
    cart.value = []
    note.value = ''
    window.location.reload()
  } catch (e) {
    alert('Có lỗi khi thanh toán.')
    console.error(e)
  }
}

const total = computed(() => cart.value.reduce((s, c) => s + c.price * c.qty, 0))

function createNewTable() {
  showAddTable.value = true
}

async function addTable() {
  const name = (newTableName.value || '').trim()
  if (!name) {
    alert('Vui lòng nhập tên bàn!')
    return
  }
  // prepare payload the backend expects
  const payload = {
    name: name,
    status: "0",
    createdAt: new Date().toISOString()
  }
  try {
    await createTable(payload)
    alert('Tạo bàn thành công!')
    newTableName.value = ''
    showAddTable.value = false
    tables.value = await getTable()
  } catch (e) {
    console.error('Error creating table', e)
    alert('Có lỗi khi tạo bàn.')
  }
}

function formatMoney(n) {
  return n.toLocaleString('vi-VN') + '₫'
}

async function onFoodAdded() {
  showAddFood.value = false
  foods.value = await getFoods()
}

async function addCategory() {
  const name = newCategory.value.trim()
  if (!name) {
    alert('Vui lòng nhập tên danh mục!')
    return
  }
  if (categories.value.includes(name)) {
    alert('Danh mục đã tồn tại!')
    return
  }
  const data = {
    name: name
  }
  await createCat(data)
  newCategory.value = ''
  showAddCategory.value = false
}
</script>

<style scoped>
/* Dùng nguyên CSS từ HTML KiotViet */
:root {
  --accent: #ff6b35;
  --bg: #f6f6f8;
  --card: #ffffff;
  --muted: #777
}

* {
  box-sizing: border-box;
  font-family: Inter, ui-sans-serif, system-ui
}

body {
  margin: 0;
  background: var(--bg);
  color: #111
}

.app {
  display: grid;
  grid-template-columns:300px 1fr 380px;
  gap: 18px;
  height: 100vh;
  padding: 18px
}

.left {
  display: flex;
  flex-direction: column;
  gap: 12px
}

.card {
  background: var(--card);
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06)
}

.search {
  display: flex;
  gap: 8px
}

.search input {
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #e6e6f0
}

.categories {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px
}

.cat {
  padding: 8px 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #eee;
  cursor: pointer
}

.cat.active {
  background: linear-gradient(90deg, var(--accent), #ff8e66);
  color: #fff;
  border: 0
}

.tables {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px
}

.table {
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #eee;
  cursor: pointer
}

.table.active {
  background: #222;
  color: #fff
}

.table.status-0 {
  background: #fff; /* trắng */
  color: #222;
}

.table.status-1 {
  background: #ff0000; /* xanh lá */
  color: #fff;
}

.table.status-2 {
  background: #58ff00; /* đỏ */
  color: #fff;
}

.center {
  display: flex;
  flex-direction: column
}

.center-header {
  display: flex;
  gap: 12px;
  align-items: center
}

.center-header h3 {
  margin: 0
}

.foods {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.food {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  cursor: pointer;
  min-height: 100px; /* để card đồng đều */
}

.food .name {
  font-weight: 600;
  font-size: 15px;
  color: #222;
}

.food .meta {
  font-size: 13px;
  color: var(--muted);
}

.food .price {
  color: var(--accent);
  font-weight: 700;
  margin-top: auto; /* đẩy xuống cuối */
}

.right {
  display: flex;
  flex-direction: column;
  gap: 12px
}

.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center
}

.cart-list {
  flex: 1;
  overflow: auto;
  padding-right: 6px
}

.cart-item {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 8px;
  background: #fff;
  border: 1px solid #eee
}

.qty {
  display: flex;
  align-items: center;
  border-radius: 6px;
  overflow: hidden
}

.qty button {
  background: #f2f2f4;
  border: 0;
  padding: 6px 8px;
  cursor: pointer
}

.qty span {
  padding: 6px 10px;
  min-width: 32px;
  text-align: center
}

.cart-bottom {
  background: #fff;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #eee
}

.btn {
  display: inline-block;
  padding: 10px 14px;
  border-radius: 8px;
  border: 0;
  background: var(--accent);
  color: #fff;
  cursor: pointer
}

.btn.ghost {
  background: transparent;
  color: var(--accent);
  border: 1px solid rgba(0, 0, 0, 0.06)
}

@media (max-width: 1000px) {
  .app {
    grid-template-columns:1fr;
    grid-auto-rows: auto;
    overflow: auto
  }

  .right {
    order: 3
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  min-width: 320px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}
</style>
